import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../estilo.css";

export default function Rodape() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className="quantum-footer">
        <div className="footer-content container-fluid">
          <div className="row">
            {/* Coluna esquerda */}
            <div className="col-sm-4 footer-section">
              <img
                src={require("../img/QuantumEA.png")}
                alt="Quantum Trades"
                className="footer-logo"
              />
              <p className="footer-description">
                Quantum Trades é um ecossistema de robôs para MetaTrader 5,
                com soluções para automação, leitura de viés e operações
                mais dinâmicas em diferentes cenários de mercado.
              </p>

              <div style={{ marginTop: "16px" }}>
                <Link to="/planos" className="footer-link" style={{ display: "inline-block", marginRight: "14px" }}>
                  Ver planos
                </Link>
                <Link to="/cadastro" className="footer-link" style={{ display: "inline-block" }}>
                  Criar conta
                </Link>
              </div>
            </div>

            {/* Coluna do meio */}
            <div className="col-sm-4 footer-section">
              <h4>Navegação</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/">Início</Link>
                </li>
                <li>
                  <Link to="/planos">Planos</Link>
                </li>
                <li>
                  <Link to="/indicadores">Indicadores</Link>
                </li>
                <li>
                  <Link to="/portifolio">Portfólio</Link>
                </li>
                <li>
                  <Link to="/cadastro">Cadastro</Link>
                </li>
                <li>
                  <Link to="/contato">Contato</Link>
                </li>
              </ul>
            </div>

            {/* Coluna direita */}
            <div className="col-sm-4 footer-section">
              <h4>Contato</h4>

              <p>
                Email:{" "}
                <a href="mailto:contato@quantumtrades.com.br">
                  contato@quantumtrades.com.br
                </a>
              </p>

              <p>
                WhatsApp:{" "}
                <a
                  href="https://wa.me/5542984241307"
                  target="_blank"
                  rel="noreferrer"
                >
                  (42) 98424-1307
                </a>
              </p>

              <p>
                YouTube:{" "}
                <a
                  href="https://www.youtube.com/@QuantumTradesBR"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  @QuantumTradesBR
                </a>
              </p>

              <p>
                Telegram:{" "}
                <a
                  href="https://t.me/QuantumTradesBr"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link"
                >
                  @QuantumTradesBR
                </a>
              </p>

              <div className="telegram-qrcode-wrapper">
                <img
                  src={require("../img/LinkTelegramQuantemTradesBR.png")}
                  alt="Grupo Telegram Quantum Trades"
                  className="telegram-qrcode-small"
                />
              </div>
            </div>
          </div>

          {/* Faixa final */}
          <div
            style={{
              marginTop: "30px",
              paddingTop: "22px",
              borderTop: "1px solid rgba(255,255,255,0.08)",
              textAlign: "center",
            }}
          >
            <p className="footer-terms" style={{ marginTop: 0 }}>
              O uso dos robôs da Quantum Trades envolve riscos financeiros.
              Resultados passados não garantem resultados futuros.
              Ao utilizar qualquer solução da plataforma, você concorda com os nossos termos de uso.
            </p>

            <div style={{ marginTop: "10px" }}>
              <button className="footer-terms-btn" onClick={() => setOpen(true)}>
                Ler termos completos
              </button>
            </div>

            <p className="footer-copy">
              © {new Date().getFullYear()} Quantum Trades — Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>

      {open && (
        <div className="termos-modal-overlay" onClick={() => setOpen(false)}>
          <div className="termos-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Termos e Condições de Uso</h3>
            <div className="termos-text">{TERMO_COMPLETO}</div>
            <button className="footer-terms-btn" onClick={() => setOpen(false)}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}

const TERMO_COMPLETO = (
  <div>
    <p>
      O usuário (“USUÁRIO”), ao instalar, ativar, utilizar ou realizar qualquer
      operação com os robôs da Quantum Trades dentro da plataforma MetaTrader 5 (MT5),
      declara estar ciente e de acordo com os seguintes termos:
    </p>

    <p>
      <strong>1 –</strong> O USUÁRIO utiliza os sistemas por livre vontade,
      autorizando o tratamento dos dados necessários ao funcionamento,
      estatísticas internas, segurança, registro de logs e melhoria contínua do sistema.
    </p>

    <p>
      <strong>2 –</strong> O USUÁRIO declara compreender plenamente o
      funcionamento dos robôs, bem como todos os riscos financeiros envolvidos
      em operações automatizadas.
    </p>

    <p>
      <strong>3 –</strong> Toda configuração de volume, risco, reentradas,
      distâncias, metas, stops, correlações e parâmetros operacionais é de
      responsabilidade exclusiva do USUÁRIO.
    </p>

    <p>
      <strong>4 –</strong> A Quantum Trades não garante lucros, não presta
      consultoria financeira, não sugere estratégias e não se responsabiliza por
      perdas decorrentes de configurações inadequadas, falhas técnicas,
      volatilidade, slippage, spreads, stop outs, desconexões ou qualquer outro
      evento de mercado.
    </p>

    <p>
      <strong>5 –</strong> Os robôs da Quantum Trades operam exclusivamente sobre a
      estrutura do MetaTrader 5, desenvolvido pela MetaQuotes. Assim, a Quantum Trades
      não possui responsabilidade por erros, instabilidades ou limitações da plataforma MT5.
    </p>

    <p>
      <strong>6 –</strong> O USUÁRIO reconhece que operações no mercado Forex,
      ouro, índices e demais derivativos envolvem riscos significativos, podendo
      resultar em perdas superiores ao capital investido.
    </p>

    <p>
      <strong>7 –</strong> Resultados exibidos em backtests, demonstrações,
      portfólios e simulações são apenas estimativas e{" "}
      <strong>não representam garantia de desempenho futuro.</strong>
    </p>

    <p>
      <strong>8 –</strong> É proibida a distribuição, cópia, venda,
      compartilhamento ou uso dos robôs em qualquer sistema de terceiros sem
      autorização expressa da Quantum Trades.
    </p>

    <p>
      <strong>9 –</strong> O USUÁRIO concorda que o software executará ordens
      automaticamente, seguindo regras configuradas por ele, isentando a Quantum Trades
      de responsabilidade sobre decisões geradas pelo algoritmo.
    </p>

    <p>
      <strong>10 –</strong> O USUÁRIO concorda que erros, interrupções,
      configurações incorretas, condições extremas de mercado, gaps, spreads e
      latência podem gerar perdas, e que essas perdas são de sua total responsabilidade.
    </p>

    <p>
      <strong>11 –</strong> O uso dos robôs implica aceitação integral destes
      termos. Caso o USUÁRIO discorde de qualquer item, deve interromper
      imediatamente o uso.
    </p>

    <p>
      <strong>12 – Direito de arrependimento (7 dias):</strong> o USUÁRIO poderá
      solicitar a devolução integral dos valores pagos pela contratação em até{" "}
      <strong>7 (sete) dias corridos</strong> a contar da data da primeira contratação.
      Após esse prazo, não haverá reembolso, ainda que o sistema deixe de ser utilizado.
    </p>
  </div>
);